
const MapModelMixin = {
  initialize(attributes, options = {}) {
    this._mapModel = options.mapModel
  },

  mapModel() {
    return this._mapModel
  }
}

export default MapModelMixin